import classNames from 'classnames';
import React from 'react';
import { Dropdown } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { GA4TrackConstant, GATrackConstant, Language } from '../../utils/constants/CommonConstants';
import { UserRoleType } from '../../utils/constants/JobBoardConstants';
import PageRoute from '../../utils/constants/PageRoute';
import GA4Helper from '../../utils/helpers/GA4Helper';
import GAHelper from '../../utils/helpers/GAHelper';
import { useEMarketplaceLayoutContext } from './EMarketplaceLayoutContext';

export default function Footer(
  props: React.PropsWithChildren<{
    userRole?: UserRoleType;
  }>,
): React.FunctionComponentElement<any> {
  const { i18n, t } = useTranslation();
  const currentLangItem = Language.getLangByKey(i18n.language) || Language.en;
  const languages = [Language.th, Language.en];
  let checkBuyer: any = !props.userRole && null;

  if (props.userRole === UserRoleType.BUYER) {
    checkBuyer = true;
  } else {
    checkBuyer = false;
  }

  const { currencyCodeOptions, currencyCodeSelected, setCurrencyCodeSelected } =
    useEMarketplaceLayoutContext() || {};

  const location = useLocation();
  const isPIService = location.pathname.includes(PageRoute.PI);
  const fullYear = new Date().getFullYear();

  return (
    <>
      <footer className="footer">
        <div className="container">
          <div className="footer-item">
            <div className="item-left" id='id="pi-footer-txt-copyright-detail"'>
              <div className="font-normal">Contact Customer Service</div>
              <div className="mt-8 color-sub">
                Phone: <a href="tel:+6620344333">+66 2034 4333</a> (Mon - Fri from 9.00-18.00)
                <br />
                Email: <a href="mailto:customercare@pantavanij.com">customercare@pantavanij.com</a>
              </div>
              <div className="mt-16 color-note">
                &copy; Copyright {fullYear} pantavanij.com. All Rights Reserved.
              </div>
            </div>

            <div className="item-right">
              <div className="language d-flex">
                <Dropdown className="dropdown-btn w-auto">
                  <Dropdown.Toggle id="pi-footer-btn-language" variant="secondary">
                    <span>
                      <i className="icon-language"></i>
                      {currentLangItem?.title}
                    </span>
                  </Dropdown.Toggle>
                  <Dropdown.Menu alignRight>
                    <div className="dropdown-list">
                      {languages.map((lang, index) => (
                        <Dropdown.Item
                          id={`pi-footer-opt-language-[${index}]`}
                          key={lang.key}
                          className={classNames({
                            active: currentLangItem?.key === lang.key,
                          })}
                          onClick={() => {
                            let category =
                              checkBuyer === null
                                ? GATrackConstant.Footer
                                : checkBuyer
                                ? GATrackConstant.BuyerSearchJobBoard
                                : GATrackConstant.SupplierSearchJobBoard;
                            GAHelper.event(category, GATrackConstant.ChangeLang, `${lang.key}`);
                            GA4Helper.event(
                              GA4TrackConstant.Category.Navigation,
                              GA4TrackConstant.Action.Click,
                              `${lang.key}`,
                            );
                            i18n.changeLanguage(lang.key);
                          }}
                        >
                          {currentLangItem?.key === lang.key && <i className="icon-sm-check"></i>}
                          {lang.title}
                        </Dropdown.Item>
                      ))}
                    </div>
                  </Dropdown.Menu>
                </Dropdown>

                {currencyCodeOptions && currencyCodeOptions.length > 0 && (
                  <Dropdown className="dropdown-btn w-auto ml-1">
                    <Dropdown.Toggle id="pi-footer-btn-currency" variant="secondary">
                      <span>{t(`Common.Currency.${currencyCodeSelected}`)}</span>
                    </Dropdown.Toggle>
                    <Dropdown.Menu className="dropdown-menu-right">
                      <div className="dropdown-list">
                        {currencyCodeOptions.map((currencyCode, index) => (
                          <Dropdown.Item
                            id={`pi-footer-opt-currency-[${index}]`}
                            key={currencyCode}
                            className={classNames('m-0', {
                              active: currencyCodeSelected === currencyCode,
                            })}
                            onClick={() => {
                              setCurrencyCodeSelected && setCurrencyCodeSelected(currencyCode);
                              GA4Helper.event(
                                GA4TrackConstant.Category.Navigation,
                                GA4TrackConstant.Action.Click,
                                currencyCode,
                              );
                            }}
                          >
                            {currencyCodeSelected === currencyCode && (
                              <i className="icon-sm-check"></i>
                            )}
                            {t(`Common.Currency.${currencyCode}`)}
                          </Dropdown.Item>
                        ))}
                      </div>
                    </Dropdown.Menu>
                  </Dropdown>
                )}

                {/* <div className="dropdown dropdown-btn ml-1">
                  <button type="button" data-toggle="dropdown" className="btn dropdown-toggle">
                    <span>THB - บาท</span>
                  </button>
                  <div className="dropdown-menu dropdown-menu-right">
                    <div className="dropdown-list">
                      <a className="dropdown-item active">ภาษาไทย</a>
                      <a className="dropdown-item">English</a>
                    </div>
                  </div>
                </div> */}
              </div>
              {isPIService && (
                <div className="caption" id="pi-footer-txt-remark-currency-detail">
                  **Price according to the exchange rate of the Bank of Thailand as of 15/08/2021
                  <i className="icon-sm-alert color-sub-title ml-4px"></i>
                </div>
              )}
              {/* <div className="ml-auto">
                <a href="">นโยบายรักษาข้อมูล</a>
                <a href="">นโยบายการใช้งานคุกกี้</a>
                <a href="">ข้อตกลงการใช้งาน</a>
                <a href="">ข้อตกลงการซื้อสินค้า</a>
              </div> */}
            </div>
          </div>
        </div>
      </footer>
    </>
  );
}
